export const countriesSelector = ({
                                      language: {
                                        countries,
                                      },
                                    }) => countries;
